import React, { useState, useEffect } from 'react';
import { get_dlqi_plqi } from "../Services/Service";

function Wfirss({ uuid }) {
    const [psqiResponse, setPsqiResponse] = useState([]);

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchPsqi = async () => {
            try {
                const psqiResponse = await get_dlqi_plqi({ uuid: uuid, type: "wfirss" });
                console.log(psqiResponse);
                setPsqiResponse(psqiResponse.data.data);
            } catch (error) {
                console.error(error);
            }
        };

        fetchPsqi();
    }, [uuid]); // Run effect whenever `uuid` changes

    return (
        <div>
            {psqiResponse && psqiResponse.length >= 1 && !loading ?
                <div className='row'>
                    {/* {psqiResponse.map(psqiVal => ( */}
                    <>
                        <div className="table-responsive">
                            <table className="table mb-0 table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col">Date</th>
                                        <th scope="col">Score</th>
                                        <th scope="col">Report</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {psqiResponse.map((entry, index) => (
                                        <tr key={Math.random()}>
                                            <td className='table-text'>{entry.date}</td>
                                            <td className='table-text'>{entry.score}</td>
                                            <td className='table-text'><a target="_blank" className='dliq-btn' href={entry.link}>OPEN </a></td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                    </>
                    {/* ))} */}
                </div> : psqiResponse != null && !loading ?
                    <section className="ReportFlareUpStats">
                        <div className='NoRecordFound'>
                            <div className='row'>
                                {/* <div className='col-12 text-center'>
                                    <img src={require('../images/icon-no-record-found.jpg')} className="record-img" alt="" />
                                </div> */}
                                <div className='col-12 text-center mt-4'>
                                    <h3>No Record Found</h3>
                                </div>
                            </div>
                        </div>
                    </section> : <div className="loader loader-bar">
                        <div className='row'>
                            <div className='col-12 text-center'>
                                <img src='https://appcdn.goqii.com/storeimg/32388_1711621501.gif' alt='' />
                            </div>
                            <div className='col-12 text-center mt-4'>
                                <h3>Loading...</h3>
                            </div>
                        </div>
                    </div>
            }
        </div>
    );
}

export default Wfirss;
